<nz-layout class="social-history-section">
  @if (submenu?.length! <= 1) {
    <nz-header> </nz-header>
  }
  @if (submenu?.length! > 1) {
    <nz-header class="section-header">
      {{ "Social History" | translate }}
    </nz-header>
  }
  <nz-content>
    <!-- <app-social-history-questonaire /> -->

    <!-- <ng-container *ngFor="let cm of submenu"> -->
    <app-social-history />
    <!-- <app-dynamic-questionnaire *ngIf="cm.path==componentPaths.socialHistoryQuestionnaire" [id]="cm.path" /> -->
  <!-- </ng-container> -->
  <app-dietary-habits />
</nz-content>
</nz-layout>